import { toast } from "sonner";
import { Capacitor } from "@capacitor/core";
import { Share } from "@capacitor/share";
import { toShareLink } from "@/lib/shareLinks";

// The public share link of any in-app URL (/api/e/… rich card that opens the installed app)
// lives in lib/shareLinks.js — re-exported here for the existing call sites.
export { toShareLink };

// Share a link everywhere:
// - Native app (Capacitor) → OS share sheet (WhatsApp, Messenger, SMS…).
// - Mobile web with the Web Share API → same native sheet.
// - Desktop / no API → copy the link.
// The shared URL is always the server-rendered Open Graph link (toShareLink) so
// WhatsApp/Facebook/Telegram render a rich Yalola card.
export async function shareUrl({ title = "Yalola", text = "", url, copiedMsg = "Lien copié 🔗", dialogTitle } = {}) {
  const link = toShareLink(url);
  try {
    if (Capacitor.isNativePlatform()) {
      await Share.share({ title, text, url: link, dialogTitle: dialogTitle || title });
      return true;
    }
    if (typeof navigator !== "undefined" && navigator.share) {
      await navigator.share({ title, text, url: link });
      return true;
    }
    await navigator.clipboard.writeText(link);
    toast.success(copiedMsg);
    return true;
  } catch (e) {
    const name = e && (e.name || "");
    if (name === "AbortError" || /cancel/i.test(String(e))) return false; // user dismissed
    try { await navigator.clipboard.writeText(link); toast.success(copiedMsg); return true; } catch { return false; }
  }
}
